import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import {apiRequest} from "../../utils/request";
import MasterInventoryGrid from "./MasterInventoryGrid";

class MasterInventoryPage extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      items: [],
      loading: true,
    };

    this.fetchItems = this.fetchItems.bind(this);
  }

  async fetchItems() {
    let items = (await apiRequest(`/api/inventory/master`)).data || [];
    this.setState({items, loading: false});
  }

  componentDidMount() {
    this.fetchItems();
  }

  render() {
    let {items, loading} = this.state;

    return (
        <div>
          <h4 style={{marginTop: '10px'}}>Master Inventory</h4>

          <p>Current MYOB inventory. Refreshed automatically every six hours.</p>

          <div className={'pi-row'} style={{marginBottom: '35px'}}>
            <div className='pi-col-md-12'>
              <MasterInventoryGrid items={items} loading={loading} showSellItem={true} allowSupplierColumns={true}
                                   showWholesale={false}
                                   showBaseSellingPrice={true}
              />
            </div>
          </div>

        </div>
    );
  }
}

MasterInventoryPage.propTypes = {
  user: PropTypes.object.isRequired,
};

function mapStateToProps(state, ownProps) {
  return {
    user: state.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MasterInventoryPage));
